import LoginPage from "../pages/LoginPage";
import ResetPasswordForm from "../pages/admin/ResetPasswordPage";
import ForgotPasswordPage from "../pages/admin/ForgotPasswordPage";
import AdminDashboard from "../pages/dashboards/AdminDashboard";
import RequireAuth from "../components/RequireAuth";
import { sharedAdminRoutes } from "./sharedAdminRoutes"; // <== import ici

export const adminRoutes = (onLoginSuccess: (token: string) => void) => [
  {
    path: "/admin/login",
    element: <LoginPage onLoginSuccess={onLoginSuccess} />,
  },
  { path: "/admin/resetpassword", element: <ResetPasswordForm /> },
  { path: "/admin/forgot-password", element: <ForgotPasswordPage /> },
  {
    path: "/admin/dashboard",
    element: (
      <RequireAuth>
        <AdminDashboard />
      </RequireAuth>
    ),
    children: sharedAdminRoutes, // 👈 routes partagées
  },
];
